import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NumberFormatter from '../../utils/NumberFormater';
import {  IconButton, Skeleton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AppDispatch, RootState } from '../../redux/store';
import { getFund } from '../../redux/slice/fundAndTransactionSlice';
const FundsBlock = () => {
  const { fundsData, loading } = useSelector((store: RootState) => store.fund)
  const { loginInvestorId: investorId } = useSelector((store: RootState) => store.user);
  const dispatch = useDispatch<AppDispatch>()
  const memoizedFundsData = useMemo(() => fundsData, [fundsData]);

  useEffect(() => {
    if (investorId) {
      dispatch(getFund(investorId));
    }
  }, [investorId])

  const [state, setState] = useState({
    open: false,
    type: "",
    anchorEl: null,
  })
  const { open, type, anchorEl } = state;
  const handleOpen = (event: any, open: boolean, type: string) => {

    setState({ open, type, anchorEl: event.currentTarget })
  }
  const handleClose = () => {
    setState((prev) => ({
      ...prev,
      open: false,
      anchorEl: null,
    }))
  }




  return (
    <Box
      display="flex"
      justifyContent={{ xs: "flex-start", sm: "center" }}
      flexWrap="wrap"
      maxWidth={{ xs: "100%", lg: "80%", xl: "75%" }}
      bgcolor={"#087CA729"}
      borderRadius={1}
      py={{ xs: 2 }}
      px={{ xs: 2, md: 0 }}
      gap={2} // consistent gap between items
    >
              <Box
            p={2.5}
            bgcolor={"#fff"}
            textAlign={"center"}
            borderRadius={1}
            flexBasis={{
              xs: "100%",
              sm: "calc(50% - 18px)", // Half width on small screens (tablets)
              md: `calc(33% - 18px)`,
            }}
          >
            {loading ? <div className='flex flex-col flex-1' data-testid="funds-skeleton">
              <div className='flex gap-1 flex-1 justify-center items-center'>
                <Skeleton width={"50%"} height={30} />
                <Skeleton animation="wave" variant="circular" width={20} height={20} />
              </div>
              <div className='flex gap-2 flex-1 justify-center items-center'>
                <Skeleton width={"55%"} height={40} />
              </div>
            </div> :
              <>
                <Typography color='#3b3b3b' fontWeight={"500"} fontSize={{ xs: 16 }} >Total Funds</Typography>
                <Typography color='#3b3b3b' fontSize={{ md: 20, lg: 24 }} fontWeight={"600"} > $<NumberFormatter amount={memoizedFundsData.totalFund} /></Typography>
              </>
            }
          </Box>
          <Box
            p={2.5}
            bgcolor={"#fff"}
            textAlign={"center"}
            borderRadius={1}
            flexBasis={{
              xs: "100%",
              sm: "calc(50% - 18px)",
              md: `calc(33% - 18px)`,
            }}
          >
            {loading ? <div className='flex flex-col flex-1' data-testid="funds-skeleton">
              <div className='flex gap-1 flex-1 justify-center items-center'>
                <Skeleton width={"50%"} height={30} />
                <Skeleton animation="wave" variant="circular" width={20} height={20} />
              </div>
              <div className='flex gap-2 flex-1 justify-center items-center'>
                <Skeleton width={"55%"} height={40} />
              </div>
            </div>
              : <>
                <div className='flex gap-2 justify-center items-center'>
                  <Typography color='#3b3b3b' fontWeight={500} sx={{ textWrap: "nowrap" }} fontSize={{ xs: 16 }} >Available Funds</Typography>
                  <button
                    className='cursor-pointer'
                    onClick={(e) => { handleOpen(e, true, "available") }}
                    aria-label="available"
                    style={{ 
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      cursor: 'pointer'
                    }}
                  >
                    <svg
                      stroke="#FF5C39" fill="#FF5C39" strokeWidth="0" viewBox="0 0 16 16"
                      height="18px" width="18px" xmlns="http://www.w3.org/2000/svg"
                    >
                      <path fillRule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14zm0 1A8 8 0 108 0a8 8 0 000 16z" clipRule="evenodd"></path>
                      <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588z"></path>
                      <circle cx="8" cy="4.5" r="1"></circle>
                    </svg>
                  </button>
                </div>
                <Typography color='#3b3b3b' fontSize={{ md: 20, lg: 24 }} fontWeight={"600"} > $<NumberFormatter amount={memoizedFundsData.availableFund} /></Typography>
              </>
            }
          </Box>
          <Box
            p={2.5}
            bgcolor={"#fff"}
            textAlign={"center"}
            borderRadius={1}
            flexBasis={{
              xs: "100%",
              sm: "calc(100% - 18px)",
              md: `calc(33% - 18px)`,
            }}
          >
            {loading ? <div className='flex flex-col flex-1' data-testid="funds-skeleton">
              <div className='flex gap-1 flex-1 justify-center items-center'>
                <Skeleton width={"50%"} height={30} />
                <Skeleton animation="wave" variant="circular" width={20} height={20} />
              </div>
              <div className='flex gap-2 flex-1 justify-center items-center'>
                <Skeleton width={"55%"} height={40} />
              </div>
            </div>
              : <>
                <div className='flex gap-2 justify-center items-center'>
                  <Typography color='#3b3b3b' fontWeight={500} sx={{ textWrap: "nowrap" }} fontSize={{ xs: 16 }} >Locked Funds</Typography>
                  <button
                    className='cursor-pointer'
                    onClick={(e) => { handleOpen(e, true, "blocked") }}
                    aria-label="blocked"
                    style={{ 
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      cursor: 'pointer'
                    }}
                  >
                    <svg
                      stroke="#FF5C39" fill="#FF5C39" strokeWidth="0" viewBox="0 0 16 16"
                      height="18px" width="18px" xmlns="http://www.w3.org/2000/svg"
                    >
                      <path fillRule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14zm0 1A8 8 0 108 0a8 8 0 000 16z" clipRule="evenodd"></path>
                      <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588z"></path>
                      <circle cx="8" cy="4.5" r="1"></circle>
                    </svg>
                  </button>
                </div>
                <Typography color='#3b3b3b' fontSize={{ md: 20, lg: 24 }} fontWeight={"600"} > $<NumberFormatter amount={memoizedFundsData.lockedFund} /></Typography>
              </>
            }
            {/* <Typography color='#3b3b3b' fontWeight={500} fontSize={{ xs: 16 }} >Blocked funds</Typography> */}

          </Box>

          {/* Popover Component */}
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: "right",
            }}
            slotProps={{
              paper: {
                sx: {
                  overflow: 'visible',
                  borderRadius: "8px",
                  borderTopLeftRadius: 3,
                  paddingX: 2,
                  paddingY: 1,
                  maxWidth: 300,
                  ml: type === "available" ? 9 : 13,
                  mt: "3px",
                  boxShadow: '3px 3px 5px 2px rgba(0,0,0,0.1)',
                  '&:after,&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 8,
                    left: -9,
                    width: 18,
                    height: 18,
                    backgroundColor: 'white',
                    transform: 'rotate(45deg)',
                    boxShadow: '-3px 3px 5px -2px rgba(0,0,0,0.1)',
                  },
                },
              },
            }}
          >
            <Box>
              <Typography 
                role="heading"
                aria-label={type === "available" ? "available" : "locked"}
                variant="subtitle1" 
                fontWeight="500" 
                fontSize={16} 
                sx={{ color: "#3B3B3B" }}
              >
                {type === "available" ? "Available Funds" : "Locked Funds"}
              </Typography>
              <IconButton
                size="small"
                aria-label="close"
                onClick={handleClose}
                sx={{
                  padding: 0,
                  color: "#3B3B3B",
                }}
              >
                <CloseIcon fontSize='small' />
              </IconButton>
            </Box>
            <hr />
            <Typography
              variant="body2"
              fontWeight={"400"}
              fontSize={14}
              sx={{
                color: "#3B3B3B",
                marginTop: 1,
              }}
            >
              {type === "available" ? "Of the Total Funds, this is the amount available for placing bids on properties" : "Of the Total Funds, this is the amount used for placing bids on properties"}
            </Typography>
          </Popover>
    </Box>
  );
};

export default FundsBlock;

